import { DeleteOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Col, Form, Image, Input, Modal, Row, Select, Space, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ImageUploading, { ImageListType } from 'react-images-uploading';
import { toast } from 'react-toastify';
import icClose from '../../../assets/images/listOffice/icClose.svg';
import IcMap from '../../../assets/images/listOffice/map.svg';
import '../../../assets/styles/createOffice.scss';
import TutorialsVideo from '../../../components/TutorialsVideo';
import { Constant } from '../../../config/constant';
import {
  validateAddressOffice,
  validateDistrictOffice,
  validateEmailOffice,
  validateNameOffice,
  validateNoteOffice,
  validateProvinceOffice,
  validateUserManageOffice,
  validateWardOffice,
} from '../../../config/validators/validateOffice';
import { phoneRulesRequired } from '../../../config/validators/validators';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { createOfficeSelector, fetchCreateOffice } from '../../../redux/slice/offices/createOfficeSlice';
import { fetchListDistrict, fetchListWard, resetLocation } from '../../../redux/slice/provinceSlice';
import { handleGetUrlGuide } from '../../../utils/helpers';

const CreateOffice = ({ setOpen, open, callListOfficeApi, listUser, listProvince }: any) => {
  const [form] = Form.useForm();
  const [previewImage, setPreviewImage] = useState('');
  const [openPreview, setOpenPreview] = useState<boolean>(false);
  const [fileListDelete, setFileListDelete] = useState<[]>([]);
  const [busImg, setBusImg] = useState([]);
  const listTutorials = useAppSelector((state) => state?.tutorials?.listTutorials);
  const { district, ward } = useAppSelector((state) => state?.province);
  const provinceId = Form.useWatch('province_id', form);

  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const handleOk = () => {
    form.submit();
  };

  const handleCancelModal = () => {
    setOpen(false);
    dispatch(resetLocation());
  };
  const { loading, status } = useAppSelector(createOfficeSelector);
  const onChangeBusImage = (imageList: ImageListType) => {
    setBusImg(imageList as never[]);
  };

  const handleErrorUpload = (errors: any, files: any) => {
    if (errors?.acceptType) {
      toast.error('Ảnh tải lên phải thuộc 1 trong 4 định dạng sau: png, jpg, jpeg, gif.');
    }
    if (errors?.maxNumber) {
      toast.error('Vui lòng tải lên tối đa 5 ảnh');
    }
  };

  function handleLocationClick() {
    if (navigator.geolocation) {
      form.setFieldsValue({
        longitude: 'loading ...',
        latitude: 'loading ...',
      });
      navigator.geolocation.getCurrentPosition(successLocate, errorLocate);
    } else {
      toast.error('Geolocation not supported');
    }
  }

  function successLocate(position: any) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    form.setFieldsValue({
      longitude: longitude,
      latitude: latitude,
    });
  }

  function errorLocate() {
    form.setFieldsValue({
      longitude: '',
      latitude: '',
    });
    toast.error('Không thể truy xuất vị trí của bạn');
  }

  // Filter `option.label` match the user type `input`
  const filterOption = (input: string, option?: { label: string; value: any }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  const onFinish = async (values: any) => {
    let listImages = busImg?.map((image: any) => image?.dataURL);
    values.images = listImages?.filter((image) => !image?.includes('https://'));

    if (fileListDelete.length) {
      values.images_delete = fileListDelete;
    }
    const response = await dispatch(fetchCreateOffice(values));
    if (response?.payload) {
      setOpen(false);
    }
    callListOfficeApi();
  };

  useEffect(() => {
    if (status === Constant.DEFAULT_STATUS && loading) {
      setOpen(false);
    }
  }, [status]);

  const selectProvince =
    listProvince?.length > 0
      ? listProvince.map((item: any) => ({
          value: +item.id,
          label: item.name,
        }))
      : [];
  const selectDistrict =
    district?.length > 0
      ? district.map((item: any) => ({
          value: +item.id,
          label: item.name,
        }))
      : [];
  const selectWard =
    ward?.length > 0
      ? ward.map((item: any) => ({
          value: +item.id,
          label: item.name,
        }))
      : [];

  const selectUser =
    listUser?.length > 0
      ? listUser.map((item: any) => ({
          value: +item.id,
          label: item.name,
        }))
      : [];

  const handleChangeProvince = (value: any, option: any) => {
    dispatch(fetchListDistrict({ province_id: value }));
    form.setFieldValue('district_id', undefined);
    form.setFieldValue('ward_id', undefined);
  };
  const handleChangeWard = (value: any, option: any) => {
    dispatch(fetchListWard({ district_id: value }));
    form.setFieldValue('ward_id', undefined);
  };

  return (
    <>
      <Modal
        title={
          <Row style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}>
            <Typography.Text className="fw-600 fs-18 ">{t('Thêm văn phòng nhà xe')}</Typography.Text>
            <Space size={10} align="center">
              <TutorialsVideo url_youtube={handleGetUrlGuide(listTutorials, 3)} />
              <Image src={icClose} style={{ cursor: 'pointer' }} preview={false} onClick={handleCancelModal} />
            </Space>
          </Row>
        }
        open={open}
        onOk={handleOk}
        onCancel={handleCancelModal}
        maskClosable={false}
        closeIcon={false}
        okText="Lưu"
        cancelText="Đóng"
        width={834}
        styles={{
          body: { height: '580px', overflowY: 'auto', overflowX: 'hidden' },
        }}
        className="modal-create-office scroll-custom-modal"
        footer={(_, { OkBtn, CancelBtn }: any) => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 24,
            }}
            className="footer-edit-modal-office"
          >
            <div className="modal-btn-user d-flex gap-12">
              <CancelBtn className="modal-cancel-btn" />
              <OkBtn style={{ width: 140 }} />
            </div>
          </div>
        )}
      >
        <Form form={form} onFinish={onFinish} layout="vertical" className="form-create-office">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="name" label={t('Tên văn phòng')} rules={validateNameOffice} className="required">
                <Input placeholder={t('Nhập tên văn phòng')} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="name_online" label={t('Tên online')}>
                <Input placeholder={t('Nhập tên văn phòng')} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col xs={24} md={8}>
              <Form.Item
                name="province_id"
                label={t('Tỉnh/ Thành phố')}
                rules={validateProvinceOffice}
                className="required"
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterOption}
                  placeholder={t('Chọn tỉnh/ thành phố')}
                  options={selectProvince}
                  onChange={(value: any, option: any) => handleChangeProvince(value, option)}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="district_id"
                className="form-item-name required"
                label={t('Quận / Huyện')}
                validateTrigger={['onChange', 'onBlur']}
                rules={validateDistrictOffice}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterOption}
                  placeholder="Chọn quận / huyện"
                  options={selectDistrict}
                  onChange={(value: any, option: any) => handleChangeWard(value, option)}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="ward_id"
                className="form-item-name required-none"
                label={t('Phường / Xã')}
                validateTrigger={['onChange', 'onBlur']}
                // rules={validateWardOffice}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterOption}
                  placeholder="Chọn phường / xã"
                  options={selectWard}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={9}>
              <Form.Item
                name="user_id"
                label={t('Người quản lý')}
                rules={validateUserManageOffice}
                className="required"
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterOption}
                  placeholder={t('Chọn người quản lý')}
                  options={selectUser}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="phone" label={t('Số điện thoại')} className="required" rules={phoneRulesRequired}>
                <Input placeholder={t('Nhập số điện thoại')} />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item name="email" label={t('Email')} rules={validateEmailOffice} className="required">
                <Input placeholder={t('Nhập email')} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="address" label="Địa chỉ" rules={validateAddressOffice} className="required">
                <Input placeholder={t('Nhập địa chỉ')} />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ display: 'none' }}>
            <Button
              className="btn-locate"
              onClick={handleLocationClick}
              style={{
                marginBottom: 15,
              }}
            >
              <Image src={IcMap} preview={false} className="mb-1 pe-2" />
              {t('Sử dụng vị trí hiện tại')}
            </Button>
          </Row>
          <Row gutter={24} style={{ display: 'none' }}>
            <Col xs={24} md={12}>
              <Form.Item name="longitude" className="form-item-name required" validateTrigger={['onChange', 'onBlur']}>
                <Input autoComplete="off" addonBefore="Longitude" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="latitude" className="form-item-name required" validateTrigger={['onChange', 'onBlur']}>
                <Input autoComplete="off" addonBefore="Latitude" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <a href="https://www.google.com/maps" target="_blank" rel="noreferrer">
              <Button
                className="btn-locate"
                style={{
                  marginBottom: 10,
                }}
              >
                <Image src={IcMap} preview={false} className="mb-1 pe-2" />
                {t('Sử dụng google map')}
              </Button>
            </a>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="map_link" className="required">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="note" label={t('Ghi chú')} rules={validateNoteOffice}>
                <Input.TextArea rows={4} placeholder={t('Nhập ghi chú')} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24}>
              <span className="fw-500 text-color">Ảnh văn phòng</span>
              <Form.Item name="images" className="list_image_car">
                <ImageUploading
                  multiple
                  value={form.getFieldValue('images')}
                  onChange={onChangeBusImage}
                  maxNumber={5}
                  acceptType={['jpg', 'gif', 'png', 'jpeg']}
                  onError={handleErrorUpload}
                >
                  {({ imageList, onImageUpload, onImageRemove, isDragging, dragProps }) => (
                    <div className="Upload">
                      <Row className="h-100" gutter={[16, 16]}>
                        {imageList?.length > 0 &&
                          imageList?.map((image, index) => (
                            <Col span={6} key={index} className="Upload__item">
                              <div className="Upload__item__wrapper">
                                <img className="Upload__item__image" src={image?.dataURL} alt="" />
                                <div className="Upload__item__remove">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setPreviewImage(image?.dataURL as any);
                                      setOpenPreview(true);
                                    }}
                                    className="border-0 bg-transparent"
                                  >
                                    <EyeOutlined className="fs-18 fw-500 white icon-remove" />
                                  </button>
                                  <button
                                    type="button"
                                    className="border-0 bg-transparent"
                                    onClick={() => {
                                      const startIndex = image?.dataURL?.indexOf('/bus/images/');
                                      setFileListDelete(
                                        (fileList) => [...fileList, image?.dataURL?.slice(startIndex)] as any,
                                      );
                                      onImageRemove(index);
                                    }}
                                  >
                                    <DeleteOutlined className="fs-18 fw-500 white icon-remove" />
                                  </button>
                                </div>
                              </div>
                            </Col>
                          ))}
                        <Col span={6} className="Upload__item">
                          <button
                            type="button"
                            style={isDragging ? { color: 'red' } : undefined}
                            onClick={onImageUpload}
                            className="Upload__item__button"
                            {...dragProps}
                          >
                            <div>
                              <div className="fs-18 fw-500 text-color-default">
                                <UploadOutlined className="fs-24" /> Tải ảnh lên
                              </div>
                            </div>
                          </button>
                        </Col>
                      </Row>
                    </div>
                  )}
                </ImageUploading>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Modal footer={null} open={openPreview} onCancel={() => setOpenPreview(false)} width={700}>
          <div className="w-100" style={{ padding: '16px' }}>
            <img className="w-100" src={previewImage} alt="preview" />
          </div>
        </Modal>
      </Modal>
    </>
  );
};

export default CreateOffice;
